<script setup>
import { useSeo } from '@/composables/useSeo'
import AppHeader from '@/components/common/AppHeader.vue'
import AppFooter from '@/components/common/AppFooter.vue'

useSeo()
</script>

<template>
  <AppHeader />
  <main class="main-content">
    <RouterView />
  </main>
  <AppFooter />
</template>

<style lang="scss">
.main-content {
  min-height: calc(100vh - 72px); // 72px = altura del header
}
</style>
